
import Hebcal from 'hebcal';
import React, { Component } from 'react';
import '../App.css';
import myHebcal from '../Codes/myHebcal';
import CalendarAPI from '../Codes/CalendarAPI';
import DropdownMonth from './DropdownMonth';
import DropdownDay from './DropdownDay';
import RepeatCheckBox from './RepeatCheckBox';

//var days=['א','ב','ג','ד','ה','ו','ז','ח','ט','י','יא','יב','יג','יד','טו','טז','יז','יח','יט','כ','כא','כב','כג','כד','כה','כו','כז','כח','כט'];
//var months=['תשרי','חשוון','כסלו','טבת','שבט','אדר א','ניסן','אייר','סיוון','תמוז','אב','אלול'];
class DateInput extends Component {
    constructor(props){
        super(props);
        let date = myHebcal.getTodaysDate();
        let date_arr=date.toString('h').split(' ');
        this.state={
            day: date_arr[0],
            month: date_arr[1],
            year: date_arr[2],
            date: undefined,
       }
        this.onInputUpdate=this.onInputUpdate.bind(this);
        this.setHebDate= this.setHebDate.bind(this);
        this.setHebDate(date_arr[0], date_arr[1], date_arr[2]);
    }

    setHebDate(day, month, year){
        this.props.setHebDate(myHebcal.getHebDateObject(day, month, year));
    }


    updateMonth(month_str){
        this.setState({month: month_str});
        this.setHebDate(this.state.day, month_str, this.state.year);
    }

    updateDay(day_str){
        this.setState({day: day_str});
        this.setHebDate(day_str, this.state.month, this.state.year);
    }
    
    onInputUpdate(event){
        //let day=this.state.day;
        //let month=this.state.month;
        let year = this.state.year;
        if(event.target.id==="yearIn")
        {
            this.setState({year: event.target.value});
            year = event.target.value;
            this.setHebDate(this.state.day, this.state.month, year);
        }
    }

    render(){
        return(
            <div className="">
                <div className="col-12">
                    <input className="form-control input" id="yearIn" hint="year" onChange={this.onInputUpdate} value={this.state.year}/>
                </div>
                <div className="row-main">
                    <div className="col-7">
                        <DropdownMonth isLeapYear={new Hebcal.HDate("א "+'תשרי '+this.state.year).isLeapYear()}
                         currentMonth={this.state.month} updateMonth={this.updateMonth.bind(this)}/>
                    </div>
                    <div className="col-5">
                        <DropdownDay isWholeMonth={new Hebcal.HDate("א "+this.state.month+" "+this.state.year).daysInMonth()===30}
                         currentDay={this.state.day} updateDay={this.updateDay.bind(this)}/>   
                    </div>
                </div>
                <RepeatCheckBox setToYear={this.props.setToYear}/>
            </div>
        );
    }
}
export default DateInput;


// WEBPACK FOOTER //
// ./src/components/DateInput.js